<template>
  <div class="d-flex flex-column h-100 align-center justify-center" style="overflow: hidden;">
    <div v-if="room.state === 'disconnecting'" class="pa-5">
      <Loading :message="$t('session.leaving')"/>
    </div>
    <div v-else-if="room.state === 'connecting'" class="pa-5">
      <Loading :message="$t('session.gettingIn')"/>
    </div>
    <div
      v-else-if="session && room.state === 'disconnected'"
      class="text-center pa-5"
    >
      <Icon
        :width="40"
        :height="40"
        class="mb-3"
        :color="'rgba(0,0,0,.54)'"
        :icon="'access-point-network-off'"
      />
      <div class="mb-5">
        {{ $t('session.connectionLost') }}
      </div>
      <v-btn
        :color="btnPrimaryConfig.data.btn"
        :style="`color: ${btnPrimaryConfig.data.text}`"
        @click="$widget.reTry()"
      >
        {{ $t('session.goBack') }}
      </v-btn>
    </div>
    <div
      id="ocular-session-room"
      :class="session && room.state === 'connected' ? 'fill-height w-100' : 'hidden'"
    ></div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/MainService'
import StreamHealth from '@/plugins/StreamHealth'
import { VideoConference } from '@/plugins/ocular-web-rtc/jitsi/iframe-api'
// import ScreenShareStreamer from '@/plugins/screen-share-streamer'
import sessionServices from '@/services/Session'

require('@/services/LocationTracking')
require('@/plugins/ReportError')

@Component({
  components: {
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    Loading: () => import(/* webpackPrefetch: true */ '@/views/session/resources/Loading.vue'),
    Chat: () => import(/* webpackPrefetch: true */ '@/views/session/components/chat/Index.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  computed: {
    widget () {
      return this.$store.state.widget
    },
    storageRoom () {
      return this.$store.state.storage?.room ?? null
    },
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    },
    customer () {
      return this.$store.state.storage?.room?.customer ?? null
    }
  }
})
export default class Index extends Vue {
  data () {
    return {
      session: {
        isActive: true,
        data: null,
      },
      room: {
        videoConference: null,
        state: 'connecting' // connected, disconnected, connecting, disconnecting
      },
      updateSessionInterval: null
    }
  }

  async getSession () {
    try {
      const sessionId = this.$store.state.storage.room.session.id
      const response = await sessionServices.findById(sessionId)
      const res = response.data

      if (res.statusCode === 0) {
        this.session.data = res.session

        const sessionStatesInactive = [3, 5, 6, 7, 13, 14, 15, 18]
        const isActive = !sessionStatesInactive.includes(this.session.data.session_state_id)

        this.$storage.setStorageRoom(this.session.data)

        return {
          data: this.session.data,
          isActive
        }
      } else {
        return {
          data: null,
          isActive: false
        }
      }
    } catch (e) {
      console.error(e)
      return {
        data: null,
        isActive: false
      }
    }
  }

  exit () {
    if (this.$organization.totemMode().isActive) {
      Vue.prototype.$storage.setState(1)
      setTimeout(() => {
        this.$widget.reTry()
      }, 1000);
      // this.$router.replace({ path: '/totem', query: { setAvailable: true } })
      //   .catch((error) => {})
    } else if (this.$organization.requireQuestion()) {
      Vue.prototype.$storage.setState(6)
      this.$router.replace({ path: '/questions' })
    } else if (!this.wasRated) {
      Vue.prototype.$storage.setState(5)
      this.$router.replace({ path: '/calification' })
    } else {
      Vue.prototype.$storage.setState(1)
      this.$router.replace({ path: '/' })
      this.$widget.hide()
    }
  }

  // async startScreenShare () {
  //   const sessionId = this.storageRoom.session.id
  //   const socket = this.$signalSocket
  //   const streamer = new ScreenShareStreamer(socket, sessionId);

  //   streamer.addEventListener('shareStarted', () => {
  //     console.log('Screen sharing started');
  //   });

  //   streamer.addEventListener('frameCapture', (event) => {
  //     console.log(`Frame ${event.detail.frame_id} captured, size: ${event.detail.size}`);
  //   });

  //   streamer.startScreenShare();
  // }

  // async stopScreenShare () {
  //   const sessionId = this.storageRoom.session.id
  //   const socket = this.$signalSocket
  //   const streamer = new ScreenShareStreamer(socket, sessionId);

  //   streamer.addEventListener('shareStopped', () => {
  //     console.log('Screen sharing stopped');
  //   });

  //   streamer.stopScreenShare();
  // }

  async callStartedActions () {
    const sessionId = this.storageRoom.session.id

    await this.$socketEvents.connectListen()
    this.$socketEvents.joinTotemRoom()
    this.$socketEvents.updateDeviceState('onCall')
    this.$socketEvents.joinToSessionRoom(sessionId)
    this.$widget.setBuyOrderSessionId()
    this.$locationTracking.trackLocation()
    this.$store.commit('SET_ACTIVE_CALL', true)
    this.$tabsManager.callStarted()

    this.startIntervals()

    this.$mediaDevices.checkMediaAccess()
      .then((mediaAccess) => {
        this.$socketEvents.updateDeviceMetadata({
          mediaAccess: mediaAccess
        })
      })

      try {
        await this.$signalSocketEvents.connectListen()
          .then(() => {
            // this.startScreenShare()
            // this.$signalSocketEvents.updateDeviceState('onCall')
            // this.$signalSocketEvents.joinTotemRoom()
            this.$signalSocketEvents.joinToSessionRoom(sessionId)

            this.$mediaDevices.checkMediaAccess()
              .then((mediaAccess) => {
                this.$signalSocketEvents.updateDeviceMetadata({
                  mediaAccess: mediaAccess
                })
              })
          })
      } catch (error) {
        console.error('Error connecting to signal socket:', error)
      }
  }

  callEndedActions () {
    this.clearIntervals()

    this.$store.commit('SET_ACTIVE_CALL', false)
    this.$tabsManager.callFinished()
    this.$widget.clearHistory()
    this.$widget.setBuyOrderSessionId(true)
    this.$widget.setSessionCammerVar(null)
    this.$widget.finishPostMessage()

    this.videoConference.resetSubscribers()
    this.videoConference.hangup()
    this.$storage.setStorageRoom(null)
    // this.stopScreenShare()

    this.exit()
  }

  clearIntervals () {
    clearInterval(this.updateSessionInterval)
  }

  startIntervals () {
    this.clearIntervals()

    this.updateSessionInterval = setInterval(async () => {
      if (!this.videoConference.subscribers.length) {
        this.session = await this.getSession()

        if (!this.session.isActive) {
          this.room.state = 'disconnecting'
          this.callEndedActions()
        }
      }
    }, 8000)
  }

  async updateCammer () {
    const data = {
      route: `ocular/session/${this.storageRoom.session.id}/user`,
      params: {}
    }

    return MainService.get(data)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          const user = res.user

          this.$widget.setSessionCammerVar(user)
          Vue.prototype.$storage.setCammer({ user })
          StreamHealth.checkUserStreamHealth(user)
        }
      })
  }

  initCall () {
    const roomName = this.$store.state.storage.room.session.id
    this.videoConference = new VideoConference('avatar-services.tricotcorp.cl')

    this.videoConference.init({
      roomName: roomName.toString(),
      userInfo: {
        displayName: this.customer?.name ?? 'Cliente',
        email: this.customer?.email ?? ''
      },
      configOverwrite: {
        startWithVideoMuted: false,
        startWithAudioMuted: false
      }
    })

    this.videoConference.onCustomEvent('videoConferenceJoined', (event) => {
      this.room.state = 'connected'
      this.callStartedActions()
    })

    this.videoConference.onCustomEvent('connectionFailed', (event) => {
      this.room.state = 'disconnected'
    })

    this.videoConference.onCustomEvent('participantJoined', (event) => {
      this.updateCammer()
      this.videoConference.addSubscriber(event)
    })

    this.videoConference.onCustomEvent('participantLeft', (event) => {
      this.videoConference.removeSubscriber(event)
    })

    // this.$listenSocket.on('disconnect_session', (arg) => {
    //   if (['admin-app', 'cammer-app'].includes(arg.from)) {
    //     this.room.state = 'disconnecting'
    //     this.callEndedActions()
    //   }
    // })

    this.$signalSocket.on('session_finished', (arg) => {
      this.room.state = 'disconnecting'
      this.callEndedActions()
    })
  }

  async mounted () {
    this.session = await this.getSession()

    if (this.session.isActive) {
      this.initCall()
    } else {
      this.exit()
    }
  }

  beforeDestroy() {
    this.videoConference?.dispose()

    if (this.$signalSocket) {
      this.$signalSocket.off('session_finished')
    }

    setTimeout(() => {
      this.videoConference = null
    }, 500);
  }
}
</script>

<style scoped>
#ocular-session-room {
  background-color: #000;
}

.fill-height {
  height: 100% !important;
}

.hidden {
  visibility: hidden !important;
  opacity: 0 !important;
  height: 0 !important;
  transition: all .5s;
}

.w-100 {
  width: 100% !important;
}
</style>
